import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Export the global axios instance so it uses the auth headers set in AuthContext
export { axios };

// Alternative named export for clarity
export const axiosInstance = axios;
